import React from 'react';

export type ShowIfProps = {
    showIf?: boolean | string;
};

export const ShowIf: React.FC<ShowIfProps> = ({ showIf, children }) => {
    return showIf ? <>{children}</> : null;
};
